import React from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
    Text,
    ContainedButton,
    StyledCard,
    StyledCardContent,
    IOSSwitch,
    TimePicker,
    OutlinedButton,
    StyledFormHelperText,
    SessionCard,
    TimeIcon,
} from '../../index';

import { StyledInputCard, StyledTimeBox } from './style';

const SessionCardContainer = ({
    inputValue,
    selectedDay,
    isManage,
    setIsManage,
    handleSwitchChange,
    handleTimeChange,
    handleCancel,
    handleSave,
    disabled,
    errors,
    selectedStaff,
    sessionsContainerHeight,
}) => {
    const history = useHistory();

    const handleRedirect = (id, type) => {
        history.push(`/provider/session/${type}/${id}`);
    };
    const handleDuplicate = (id, type) => {
        history.push(`/provider/calendar/${type}/duplicate/${id}`);
    };

    return (
        <StyledCard padding="15px">
            <StyledCardContent style={{ height: '100%' }}>
                {isManage ? (
                    <div
                        style={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div>
                            <Text $fontSize="20px" $bold>
                                Manage schedule
                            </Text>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: '10px',
                                    marginTop: '10px',
                                }}
                            >
                                <StyledInputCard>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        <Text $fontSize="16px">Appointment</Text>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <IOSSwitch
                                                checked={inputValue.appointment}
                                                onChange={handleSwitchChange}
                                                name="appointment"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Text $fontSize="16px">Walk-in</Text>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <IOSSwitch
                                                checked={inputValue.walkIn}
                                                onChange={handleSwitchChange}
                                                name="walkIn"
                                            />
                                        </div>
                                    </div>
                                    {errors.find((value) => value.property === 'appointment') && (
                                        <StyledFormHelperText error>
                                            {
                                                errors.find(
                                                    (value) => value.property === 'appointment'
                                                )?.message
                                            }
                                        </StyledFormHelperText>
                                    )}
                                </StyledInputCard>
                                <StyledInputCard>
                                    <Text $fontSize="16px">Online Period</Text>
                                    <TimePicker
                                        id="onlineStart"
                                        name="onlineStart"
                                        label="Start time"
                                        placeholder="Select"
                                        value={inputValue.onlineStart}
                                        onChange={(value) => handleTimeChange(`onlineStart`, value)}
                                        helperText={
                                            errors.find((value) => value.property === 'onlineStart')
                                                ?.message
                                        }
                                    />

                                    <TimePicker
                                        id="onlineEnd"
                                        name="onlineEnd"
                                        label="End time"
                                        placeholder="Select"
                                        value={inputValue.onlineEnd}
                                        onChange={(value) => handleTimeChange(`onlineEnd`, value)}
                                        helperText={
                                            errors.find((value) => value.property === 'onlineEnd')
                                                ?.message
                                        }
                                    />
                                </StyledInputCard>
                                <StyledInputCard>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        <Text $fontSize="16px">Lunch Break</Text>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <IOSSwitch
                                                checked={inputValue.break}
                                                onChange={handleSwitchChange}
                                                name="break"
                                            />
                                        </div>
                                    </div>
                                    <TimePicker
                                        id="breakStart"
                                        name="breakStart"
                                        label="Start time"
                                        placeholder="Select"
                                        value={inputValue.breakStart}
                                        onChange={(value) => handleTimeChange(`breakStart`, value)}
                                        disabled={!inputValue.break}
                                        helperText={
                                            errors.find((value) => value.property === 'breakStart')
                                                ?.message
                                        }
                                    />

                                    <TimePicker
                                        id="breakEnd"
                                        name="breakEnd"
                                        label="End time"
                                        placeholder="Select"
                                        value={inputValue.breakEnd}
                                        onChange={(value) => handleTimeChange(`breakEnd`, value)}
                                        disabled={!inputValue.break}
                                        helperText={
                                            errors.find((value) => value.property === 'breakEnd')
                                                ?.message
                                        }
                                    />
                                </StyledInputCard>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: '10px',
                                marginTop: '10px',
                            }}
                        >
                            <OutlinedButton onClick={handleCancel}>Cancel</OutlinedButton>
                            <ContainedButton onClick={handleSave} disabled={disabled}>
                                Save
                            </ContainedButton>
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            height: '100%',
                            display: 'grid',
                            rowGap: '10px',
                            gridTemplateRows: selectedStaff === '' ? 'auto 1fr' : 'auto auto 1fr',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                rowGap: '10px',
                            }}
                        >
                            <Text $fontSize="20px" $bold>
                                Sessions
                            </Text>
                            <Text $fontSize="14px" $color="gray2">
                                {dayjs(selectedDay?.date).format('DD MMMM YYYY')}
                            </Text>
                        </div>
                        {selectedStaff !== '' && (
                            <StyledCard $borderColor="gray6" padding="15px">
                                <StyledCardContent
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        rowGap: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            rowGap: '5px',
                                        }}
                                    >
                                        <Text $color="gray1">Online Period</Text>
                                        <TimeBox
                                            startTime={selectedDay.onlineStart}
                                            endTime={selectedDay.onlineEnd}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            rowGap: '5px',
                                        }}
                                    >
                                        <Text $color="gray1">Break Time</Text>
                                        <TimeBox
                                            startTime={selectedDay.breakStart}
                                            endTime={selectedDay.breakEnd}
                                        />
                                    </div>
                                    <ContainedButton
                                        $height="36px"
                                        style={{ padding: '0 10px 0 0' }}
                                        onClick={() => setIsManage(true)}
                                        disabled={
                                            selectedDay.date.isBefore(dayjs(), 'date') || disabled
                                        }
                                    >
                                        <Text $fontSize="14px" $color="white">
                                            Manage Schedule
                                        </Text>
                                    </ContainedButton>
                                </StyledCardContent>
                            </StyledCard>
                        )}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                alignContent: 'flex-start',
                                rowGap: '10px',
                                maxHeight: sessionsContainerHeight,
                                overflowY: 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            {_.isEmpty(selectedDay.meets) ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%',
                                    }}
                                >
                                    <Text $color="gray5" $fontSize="14px">
                                        Empty Session
                                    </Text>
                                </div>
                            ) : (
                                selectedDay.meets.map((meet) => (
                                    <SessionCard
                                        data={meet}
                                        key={meet.id}
                                        onClick={() => handleRedirect(meet.id, meet.type)}
                                        small
                                        showProvider={selectedStaff === ''}
                                        onDuplicate={() => handleDuplicate(meet.id, meet.type)}
                                    />
                                ))
                            )}
                        </div>
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

SessionCardContainer.propTypes = {
    inputValue: PropTypes.object,
    selectedDay: PropTypes.object,
    isManage: PropTypes.bool,
    setIsManage: PropTypes.func,
    handleSwitchChange: PropTypes.func,
    handleTimeChange: PropTypes.func,
    handleCancel: PropTypes.func,
    handleSave: PropTypes.func,
    disabled: PropTypes.bool,
    errors: PropTypes.array,
    selectedStaff: PropTypes.string,
    sessionsContainerHeight: PropTypes.string,
};

export default SessionCardContainer;

const TimeBox = ({ startTime, endTime }) => {
    return (
        <StyledTimeBox $borderColor={startTime && endTime ? 'gray4' : 'gray6'}>
            <Text $color={startTime && endTime ? 'black' : 'gray6'}>
                {startTime && endTime
                    ? `${startTime.split(':')[0]}:${startTime.split(':')[1]}-${
                          endTime.split(':')[0]
                      }:${endTime.split(':')[1]}`
                    : '00:00-00:00'}
            </Text>
            <TimeIcon width="16" height="16" fill={startTime && endTime ? 'black' : 'gray6'} />
        </StyledTimeBox>
    );
};

TimeBox.propTypes = {
    startTime: PropTypes.string,
    endTime: PropTypes.string,
};
